<template>
  <div class="space-y-4 relative">
    <div class="flex flex-row justify-between items-center px-5">
      <h2 class="text-xl text-text-brand font-serif uppercase flex-1">
        <slot name="title"></slot>
      </h2>

      <div class="flex flex-row gap-2 items-center">
        <slot name="actions"></slot>
      </div>
    </div>

    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>
